export const COLOR_MODE_COOKIE_NAME = 'lk_color_mode';
